/* CameraBebelusului – FAQ deep-link stabil (fără să sară sub header) */
(() => {
  const faqWrap = document.querySelector('.article-faq');
  if (!faqWrap) return;

  const detailsEls = faqWrap.querySelectorAll('details[id]');
  if (!detailsEls.length) return;

  // Folosim id-ul articolului ca să păstrăm starea, dacă vrei (opțional)
  const articleEl = document.querySelector('article[id^="post-"]');
  const articleId = articleEl?.id?.replace('post-', '') || 'unknown';
  const LS_KEY = `cb_faq_open_ids_${articleId}`;

  // ---- utilitare
  function getHeaderOffset() {
    // 1) încearcă variabila CSS (poți ajusta în stylesheet)
    const cssVar = getComputedStyle(document.documentElement)
      .getPropertyValue('--header-offset').trim();
    let cssOffset = parseInt(cssVar, 10);
    if (Number.isNaN(cssOffset)) cssOffset = 0;

    // 2) încearcă să detecteze un header sticky/fixed
    const header = document.querySelector('header, .header, .site-header, .shopify-section-header');
    const stickyH = header ? header.getBoundingClientRect().height : 0;

    return Math.max(cssOffset, stickyH, 0);
  }

  function smoothScrollTo(el, addGap = 8) {
    if (!el) return;
    const offset = getHeaderOffset() + (addGap || 0);
    const top = el.getBoundingClientRect().top + window.pageYOffset - offset;

    const prefersReduced = window.matchMedia?.('(prefers-reduced-motion: reduce)')?.matches;
    window.scrollTo({ top, behavior: prefersReduced ? 'auto' : 'smooth' });
  }

  // Deschide details -> așteaptă 2 cadre -> derulează (după ce layout-ul s-a așezat)
  function openAndScrollToId(id, updateHash = true) {
    const dt = document.getElementById(id);
    if (!dt || dt.tagName.toLowerCase() !== 'details') return;

    // deschide dacă e închis
    if (!dt.open) dt.open = true;

    // două rAF-uri ca să prindem reflow-ul după deschidere
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        smoothScrollTo(dt);
      });
    });

    // actualizează hash-ul fără reload
    if (updateHash) {
      if (history?.replaceState) {
        history.replaceState(null, '', `#${encodeURIComponent(id)}`);
      } else {
        location.hash = id;
      }
    }
  }

  // ---- restaurare stare (multi-open) – opțional
  function loadOpenState() {
    try {
      const raw = localStorage.getItem(LS_KEY);
      const arr = raw ? JSON.parse(raw) : [];
      return Array.isArray(arr) ? arr : [];
    } catch { return []; }
  }
  function saveOpenState() {
    const openIds = Array.from(detailsEls).filter(d => d.open).map(d => d.id);
    localStorage.setItem(LS_KEY, JSON.stringify(openIds));
  }

  // Restaurează ce era deschis data trecută
  loadOpenState().forEach(id => {
    const d = document.getElementById(id);
    if (d) d.open = true;
  });

  // Dacă pagina se încarcă cu un #hash, deschide și derulează corect
  function handleInitialHash() {
    const id = location.hash.slice(1);
    if (!id) return;
    // amână puțin ca să existe DOM-ul și să aplice CSS-ul
    setTimeout(() => openAndScrollToId(decodeURIComponent(id), false), 60);
  }
  window.addEventListener('load', handleInitialHash);
  window.addEventListener('hashchange', () => {
    const id = location.hash.slice(1);
    if (id) openAndScrollToId(decodeURIComponent(id), false);
  });

  // Click pe iconița 🔗: nu lăsa summary să toggluiască; fă noi logica completă
  document.addEventListener('click', (e) => {
    const a = e.target.closest('a.faq-link');
    if (!a) return;

    e.preventDefault();
    e.stopPropagation();

    const targetId = (a.getAttribute('href') || '').replace(/^#/, '');
    if (!targetId) return;

    // deschide, adu în viewport, setează hash
    openAndScrollToId(targetId, true);
  }, { capture: true });

  // La orice toggle manual: salvează starea
  faqWrap.addEventListener('toggle', (e) => {
    if (e.target instanceof HTMLDetailsElement) saveOpenState();
  });
})();
